import { newId } from '@battleops/localstore';
import { makeTaskDoc as make } from '@battleops/shared';

// The one shape of a new task doc — lives in shared (taskdoc.js) so the MCP writes the same fields.
// This wrapper supplies the store's id generator.
export function makeTaskDoc(task, scope = [], now = Date.now()) {
  return make(task, scope, now, newId);
}
